<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        例外
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">ハッシュ</a>
          </li>
      </ul>
    </div>
    <b-row>
      <b-col>
        <b-card>
          <b-row>
            <b-col>
              例外ファイル
            </b-col>
          </b-row>
          <hr>
          <b-form-group>
            <b-form-file v-model="file" @ondrop="bs_file" @change="bs_file" :disabled="lock" v-show="!lock"></b-form-file>
          </b-form-group>
          <div>
            <b-form-group>
              <label for="ph_md5">MD5ハッシュ</label>
              <b-form-input md="5" type="text" id="ph_md5" v-model="model.hash" :disabled="lock"></b-form-input>
            </b-form-group>
            <b-form-group>
              <label for="ph_cause">説明</label>
              <b-form-textarea :disabled="lock" :rows="3" v-model="model.cause"></b-form-textarea>
            </b-form-group>
            <b-form-group>
              <label for="is_use_true">is_alive</label><br/>
              <c-switch :disabled="lock" v-model="model.is_alive"  color="success" label variant="pill"/><br>
            </b-form-group>
          </div>
          <hr/>
          <b-button v-if="lock" size="sm" variant="warning" @click="lock = false" class="btn-add"> 編集 </b-button>
          <b-button class="btn-add" v-else size="sm" variant="success" @click="save"> 保存 </b-button>
          <b-button size="sm" variant="danger" :disabled="!lock" @click="confirm=true"> 削除  </b-button>
          <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> 一覧 </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      選択した情報を本当に削除してよろしいですか？
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
